import { render, staticRenderFns } from "./OfferReducedRefund.vue?vue&type=template&id=2dd9a2a5&scoped=true"
import script from "./OfferReducedRefund.vue?vue&type=script&lang=js"
export * from "./OfferReducedRefund.vue?vue&type=script&lang=js"
import style0 from "./OfferReducedRefund.vue?vue&type=style&index=0&id=2dd9a2a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd9a2a5",
  null
  
)

export default component.exports